<div class="post-payment-survey w-100 px-2 px-md-3">
    <button *ngIf="canGoBack" type="button" class="btn btn-link survey-back-link p-0 text-start d-flex align-items-center mb-3" [disabled]="submitting" (click)="goBack()">&lt; Volver</button>
    <p class="survey-intro text-muted mb-4">Recibimos tu pago y lo estamos validando. Antes de cerrar, contanos un poco — tu respuesta nos ayuda a mejorar Fina.</p>
    <p class="survey-section-title mb-3">{{ stepTitles[wizardStep] }}</p>
    <div class="d-flex flex-column gap-2 mb-3">
        <label *ngFor="let opt of currentOptions" class="survey-option mb-0">
            <input
                type="radio"
                [name]="'surveyStep_' + wizardStep"
                class="form-check-input flex-shrink-0 mt-1"
                [value]="opt.value"
                [checked]="currentSelection === opt.value"
                (change)="onOptionSelect(opt.value)"
            />
            <span class="survey-option-label">{{ opt.label }}</span>
        </label>
    </div>
    <div *ngIf="showsOtherInput" class="survey-other-field mb-3">
        <label class="form-label survey-other-label" [for]="'surveyOther_' + wizardStep">Especificá</label>
        <input
            type="text"
            class="form-control survey-other-input"
            [id]="'surveyOther_' + wizardStep"
            [ngModel]="otherText"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onOtherInput($event)"
            (blur)="otherTouched = true"
            placeholder="Escribí tu respuesta"
            autocomplete="off"
            [ngClass]="{ 'is-invalid': otherInvalid }"
        />
        <div class="invalid-feedback d-block" *ngIf="otherInvalid">Ingresá una respuesta válida (mínimo 3 caracteres).</div>
    </div>
    <button type="button" class="btn btn-purple survey-submit-btn w-100 mt-2" [disabled]="!canAdvance() || submitting" (click)="advance()">
        <span *ngIf="submitting" class="spinner-border spinner-border-sm me-2" role="status"></span>
        {{ isFinalStep ? 'Guardar' : 'Continuar' }}
    </button>
</div>
